import React from 'react';
import { MessageCircle, Zap, FileText, ThumbsUp, Clock, Users } from 'lucide-react';

const HowItWorks = () => {
  const steps = [
    {
      title: "Envie o link do edital e/ou matrícula",
      description: "PDF/URL via WhatsApp para análise automática",
      icon: <MessageCircle className="h-8 w-8 text-blue-600" />
    },
    {
      title: "Receba o Resumo Flash",
      description: "Principais riscos + valor em faixa (até 8h úteis)",
      icon: <Zap className="h-8 w-8 text-blue-600" />
    },
    {
      title: "Laudo (PDF) completo",
      description: "Checklist (ônus, ocupação, dívidas) e cenários (flip/locação/financiamento) em 24–48h úteis",
      icon: <FileText className="h-8 w-8 text-blue-600" />
    },
    {
      title: "Decisão rápida",
      description: "Seguir / ajustar / evitar com base na análise completa",
      icon: <ThumbsUp className="h-8 w-8 text-blue-600" />
    }
  ];

  return (
    <section className="py-20 bg-slate-50" id="como-funciona">
      <div className="container mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-slate-900">
            Como funciona
          </h2>
          <p className="text-xl text-slate-600">
            4 passos simples para economizar horas e reduzir riscos
          </p>
        </div>
        
        <div className="relative">
          {/* Connection line */}
          <div className="absolute left-1/2 top-24 bottom-24 w-1 bg-blue-200 -translate-x-1/2 hidden md:block"></div>
          
          <div className="space-y-16 md:space-y-0 relative z-10">
            {steps.map((step, index) => (
              <div key={index} className={`flex flex-col md:flex-row items-center ${index % 2 === 1 ? 'md:flex-row-reverse' : ''}`}>
                <div className={`md:w-5/12 ${index % 2 === 0 ? 'md:text-right md:pr-16' : 'md:text-left md:pl-16'}`}>
                  <div className="bg-blue-50 inline-block px-3 py-1 rounded-full text-blue-700 font-medium text-sm mb-4">
                    Passo {index + 1}
                  </div>
                  <h3 className="text-2xl font-bold mb-4 text-slate-900">{step.title}</h3>
                  <p className="text-lg text-slate-600">{step.description}</p>
                </div>
                
                <div className="my-6 md:my-0 md:w-2/12 flex justify-center">
                  <div className="w-16 h-16 rounded-full bg-white shadow-lg flex items-center justify-center border-4 border-blue-100">
                    {step.icon}
                  </div>
                </div>
                
                <div className={`md:w-5/12 ${index % 2 === 0 ? 'md:pl-16' : 'md:pr-16'}`}>
                  <div className="bg-white p-6 rounded-xl shadow-lg border border-slate-100">
                    <div className="aspect-video rounded-lg bg-slate-100 overflow-hidden">
                      <img 
                        src={`https://images.pexels.com/photos/${7578939 + index}/pexels-photo-${7578939 + index}.jpeg`}
                        alt={`Passo ${index + 1}: ${step.title}`}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;